'use client';

import { type ReactNode } from 'react';

import { NavigationHistoryProvider } from './NavigationHistoryProvider';
import { ApiRequestCaptureProvider } from './ApiRequestCaptureProvider';
import { ConsoleLogCaptureProvider } from './ConsoleLogCaptureProvider';

interface BugReportCaptureProviderProps {
  children: ReactNode;
}

export function BugReportCaptureProvider({
  children,
}: BugReportCaptureProviderProps) {
  return (
    <NavigationHistoryProvider>
      <ConsoleLogCaptureProvider>
        <ApiRequestCaptureProvider>{children}</ApiRequestCaptureProvider>
      </ConsoleLogCaptureProvider>
    </NavigationHistoryProvider>
  );
}
